import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [

  {
    path: '/login',
    name: 'login',
    component: resolve => require(['@/views/login'], resolve),
  },
  
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/register.vue')
  },
  {
    path: '/indexbar',
    name: 'Indexbar',
    component: () => import('../views/indexbar.vue')
  },
  {
    path: '/zhmm',
    name: 'zhmm',
    component: () => import('../views/zhmm.vue')
  },
  {
    path: '/clpas',
    name: 'clierpassword',
    component: () => import('../views/clierpassword.vue')
  },
  {
    path: '/retpassword',
    name: 'retpassword',
    component: () => import('../views/Retpassword.vue')
  },
  {
    path: '/share',
    name: 'share',
    component: resolve => require(['@/views/share'], resolve),
  },
  {
    path: '/visitorint',
    name: 'visitorint',
    component: resolve => require(['@/views/visitorint'], resolve),
  },
  {
    path: '/sharepwa',
    name: 'sharepwa',
    meta:{title: '访客邀请'},
    component: resolve => require(['@/views/sharepwa'], resolve),
  },
]

const router = new VueRouter({
  routes
})

// const whiteList = ['/login','/indexbar', '/zhmm','/register']
const whiteList = ['/login','/register','/retpassword','/indexbar','/share','/sharepwa']

router.beforeEach((to,from,next)=>{
  if (to.meta.title) {
    document.title = to.meta.title
  }
  // console.log(`999`,to.meta)
  const user = window.localStorage.getItem('datauser')
 
  if (user) {   // 登录
    if (to.path === '/login') {  
      // 如果已登录，请重定向到主页
      next({ path: '/' })
      return
    } 
    next()
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免费登录白名单中，直接进入
      
      next()
    } else {
      // 没有访问权限的其他页将重定向到登录页。
      next(`/login`)
    }
  }
  
})

export default router
